import jsPDF from "jspdf";
import "jspdf-autotable";
import RECICLED from "components/photos/purchaseDelivery/recicled.png";

const LINES_PER_PAGE = 15;

const safeString = (value = "") => String(value ?? "");
const safeNumber = (value = 0) => Number(value ?? 0);
const safeArray = (value) => (Array.isArray(value) ? value : []);

const formatNumber = (num) =>
  safeNumber(num).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatNumberEuro = (num) =>
  `${safeNumber(num).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;

const formatNumberTN = (num) =>
  `${safeNumber(num).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} Tn`;

const getDateFormated = (value) => {
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const date =
    value !== null && value !== undefined && value !== ""
      ? new Date(value)
      : new Date();

  if (Number.isNaN(date.getTime())) return "";

  return `${date.getDate()} de ${meses[date.getMonth()]} de ${date.getFullYear()}`;
};

const isValidPngDataURL = (value) => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (trimmed.includes("static/media")) return true;
  if (!trimmed.startsWith("data:image/png;base64,")) return false;
  return trimmed.length > 200;
};

const getLineSubtotal = (line) => {
  const amount = safeNumber(line?.amount);
  const estimatedprice = safeNumber(line?.estimatedprice);
  const discount = safeNumber(line?.discount);
  return amount * estimatedprice * (1 - discount / 100);
};

const getLineTaxAmount = (line) => {
  const subtotal = getLineSubtotal(line);
  const tax = safeNumber(line?.tax);
  const taxincluded = Boolean(line?.taxincluded);

  if (tax === 0 || taxincluded || subtotal === 0) return 0;
  return subtotal * (tax / 100);
};

const groupTaxes = (lines) => {
  const taxMap = new Map();

  safeArray(lines).forEach((line) => {
    const taxRate = safeNumber(line?.tax);
    const taxAmount = getLineTaxAmount(line);
    if (taxRate === 0 || taxAmount === 0) return;
    taxMap.set(taxRate, (taxMap.get(taxRate) || 0) + taxAmount);
  });

  return Array.from(taxMap.entries()).map(([taxRate, taxAmount]) => ({
    taxRate,
    taxAmount,
  }));
};

const getRowHeight = (articleName) => {
  const length = safeString(articleName).length;
  if (length > 170) return 12;
  if (length > 85) return 8;
  return 4;
};

const drawHeaderPrinter = (doc, headerPrinterPurchase, initialYOffset) => {
  let yOffset = initialYOffset; 
  if (safeString(headerPrinterPurchase).trim()) {
    let counter = 0;
    safeString(headerPrinterPurchase)
      .split("\n")
      .forEach((line) => {
        if (counter === 0) {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
        } else {
          doc.setFont("helvetica", "normal");
          doc.setFontSize(7);
        }
        counter += 1;
        doc.text(line, 40, yOffset, { align: "center" });
        yOffset += 2.5;
      });
  }

  return yOffset;
};

const drawStaticHeader = (doc, purchase, headerPrinterPurchase) => {
  let yOffset = 12;
  const formattedId = safeString(purchase?.purchasenote).padStart(8, "0");
  doc.addImage(RECICLED, "PNG", 37, 4, 5, 5);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("ALBARÁN", 150, yOffset - 4, { align: "left" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(14);
  doc.text(formattedId, 150, yOffset + 2, { align: "left" });
  doc.text(safeString(purchase?.ownnumberpurchase).slice(0, 20), 150, yOffset + 8, {
    align: "left",
  });
  drawHeaderPrinter(doc, headerPrinterPurchase, yOffset);
};

const drawPartyInfo = (doc, purchase) => {
  let yOffset = 38;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(getDateFormated(purchase?.datepurchase), 195, yOffset - 8, {
    align: "right",
  });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("He recibido de D.", 15, yOffset, { align: "left" });
  doc.text("Camión nº ", 15, yOffset + 5, { align: "left" });
  doc.text("GRNP N.º ", 77, yOffset + 5, { align: "left" });
  doc.text("Obra ", 15, yOffset + 10, { align: "left" });
  doc.text("Dirección ", 15, yOffset + 15, { align: "left" });
  doc.text("E-mail ", 15, yOffset + 20, { align: "left" });
  doc.setLineDash([0.2, 0.2], 0);
  doc.line(44, yOffset, 195, yOffset);
  doc.line(34, yOffset + 5, 75, yOffset + 5);
  doc.line(95, yOffset + 5, 195, yOffset + 5);
  doc.line(25, yOffset + 10, 195, yOffset + 10);
  doc.line(32, yOffset + 15, 195, yOffset + 15);
  doc.line(26, yOffset + 20, 195, yOffset + 20);
  doc.text(safeString(purchase?.ori_tras_tradename).slice(0, 78), 44, yOffset - 1, {
    align: "left",
  });
  doc.text(
    safeString(purchase?.vehiclestore_licenseplate).slice(0, 20),
    34,
    yOffset + 4,
    { align: "left" }
  );
  doc.text(safeString(purchase?.rel_trans_grnp).slice(0, 30), 95, yOffset + 4, {
    align: "left",
  });
  doc.text(safeString(purchase?.ori_tras_workplace).slice(0, 78), 25, yOffset + 9, {
    align: "left",
  });
  doc.text(safeString(purchase?.ori_tras_street).slice(0, 78), 32, yOffset + 14, {
    align: "left",
  });
  doc.text(safeString(purchase?.ori_tras_email).slice(0, 78), 26, yOffset + 19, {
    align: "left",
  });
  doc.setLineDash([]);
};

const drawTableHeader = (doc) => {
  doc.setFillColor("#FFFFFF");
  doc.setLineWidth(0.3);
  doc.rect(15, 60, 27, 6, "FD");
  doc.rect(42, 60, 120, 6, "FD");
  doc.rect(155, 60, 20, 6, "FD");
  doc.rect(175, 60, 20, 6, "FD");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(6);
  doc.text("CANTIDAD/TONELADAS", 16, 64, { align: "left" });
  doc.setFontSize(10);
  doc.text("CONCEPTO", 98, 64, { align: "center" });
  doc.text("PRECIO", 165, 64, { align: "center" });
  doc.text("IMPORTE", 185, 64, { align: "center" });
};

const drawConceptBlock = (doc, articleName, yOffset, priceText, amountText) => {
  const text = safeString(articleName);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  if (text.length > 160) {
    doc.text(text.slice(0, 85), 43, yOffset, { align: "left" });
    doc.text(text.slice(85, 170), 43, yOffset + 4, { align: "left" });
    doc.text(text.slice(170), 43, yOffset + 8, { align: "left" });
    doc.text(priceText, 173, yOffset + 8, { align: "right" });
    doc.text(amountText, 193, yOffset + 8, { align: "right" });
    return;
  }
  if (text.length > 85) {
    doc.text(text.slice(0, 85), 43, yOffset, { align: "left" });
    doc.text(text.slice(85), 43, yOffset + 4, { align: "left" });
    doc.text(priceText, 173, yOffset + 4, { align: "right" });
    doc.text(amountText, 193, yOffset + 4, { align: "right" });
    return;
  }
  doc.text(text.slice(0, 85), 43, yOffset, { align: "left" });
  doc.text(priceText, 173, yOffset, { align: "right" });
  doc.text(amountText, 193, yOffset, { align: "right" });
};

const drawLinesPage = (doc, lines, pageIndex, totalsRef) => {
  const startIndex = pageIndex * LINES_PER_PAGE;
  const endIndex = Math.min(startIndex + LINES_PER_PAGE, lines.length);
  let yOffset = 68;

  for (let i = startIndex; i < endIndex; i += 1) {
    const line = lines[i];
    const rowHeight = getRowHeight(line?.article_namees);
    const subtotal = getLineSubtotal(line);
    const taxAmount = getLineTaxAmount(line);
    const discountedUnitPrice =
      safeNumber(line?.estimatedprice) * (1 - safeNumber(line?.discount) / 100);
    doc.setFillColor("#FFFFFF");
    doc.setLineWidth(0.2);
    doc.rect(15, yOffset - 3, 27, rowHeight, "FD");
    doc.rect(42, yOffset - 3, 120, rowHeight, "FD");
    doc.rect(155, yOffset - 3, 20, rowHeight, "FD");
    doc.rect(175, yOffset - 3, 20, rowHeight, "FD");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    const qtyText = line?.ticketweight
      ? formatNumberTN(line?.amount)
      : formatNumber(line?.amount);
    doc.text(qtyText, 41, yOffset, { align: "right" });
    totalsRef.totalPurchase += subtotal;
    totalsRef.totalTax += taxAmount;
    drawConceptBlock(
      doc,
      line?.article_namees,
      yOffset,
      formatNumberEuro(discountedUnitPrice),
      formatNumberEuro(subtotal)
    );
    yOffset += rowHeight;
  }
  return yOffset;
};

const drawTotals = (doc, yOffset, purchase, taxGroups, totalsRef) => {
  doc.setFillColor("#FFFFFF");
  doc.setLineWidth(0.3);
  doc.line(15, yOffset - 3, 195, yOffset - 3);
  doc.rect(175, yOffset - 3, 20, 4, "FD");
  yOffset += 4;
  doc.rect(175, yOffset - 3, 20, 4, "FD");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("SUBTOTAL", 173, yOffset - 4, { align: "right" });
  doc.text(formatNumberEuro(totalsRef.totalPurchase), 193, yOffset - 4, {
    align: "right",
  });
  yOffset += 4;
  if (taxGroups.length > 0) {
    taxGroups.forEach((group) => {
       doc.setFillColor("#FFFFFF");
      doc.rect(175, yOffset - 3, 20, 4, "FD");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.text(`IGIC ${group.taxRate}%:`, 173, yOffset, { align: "right" });
      doc.text(formatNumberEuro(group.taxAmount), 193, yOffset, { align: "right" });
      yOffset += 4;
    });
  } else {
     doc.setFillColor("#FFFFFF");
    doc.rect(175, yOffset - 3, 20, 4, "FD");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text("IGIC", 173, yOffset, { align: "right" });
    yOffset += 4;
  }
  doc.setFillColor("#FFFFFF");
  doc.rect(175, yOffset - 3, 20, 4, "FD");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("TOTAL", 173, yOffset, { align: "right" });
  doc.text(formatNumberEuro(totalsRef.totalPurchase + totalsRef.totalTax), 193, yOffset, {
    align: "right",
  });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`FORMA DE PAGO: ${safeString(purchase?.payment_namees)}`, 195, yOffset + 8, {
    align: "right",
  });
  return yOffset;
};

const drawSignatures = (doc, purchase) => {
  const yOffset = 115;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("DNI nº", 82, yOffset + 16, { align: "left" });
  doc.setLineDash([0.2, 0.2], 0);
  doc.line(92, yOffset + 16, 120, yOffset + 16);
  doc.setLineDash([]);
  if (isValidPngDataURL(purchase?.signature_dispatched_by)) {
    try {
      doc.addImage(purchase.signature_dispatched_by, "PNG", 17, yOffset + 2, 20, 20);
    } catch {}
  }
  if (isValidPngDataURL(purchase?.signature_client)) {
    try {
      doc.addImage(purchase.signature_client, "PNG", 95, yOffset + 2, 20, 20);
    } catch {}
  }
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Despachado por", 18, yOffset + 3, { align: "left" });
  doc.text("Conforme Cliente", 100, yOffset + 3, { align: "center" });
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.text(
    "*Este documento no tiene valor como  'Certificado Acreditativo de Gestión de Residuos de la Construcción'  según el art. 7.c. del Real Decreto 105/2008",
    12,
    yOffset + 24,
    { align: "left" }
  );
};

export const generatePurchaseSendEmailPdf = (
  purchases = [],
  headerPrinterPurchase = ""
) => {
  const normalizedPurchases = safeArray(purchases);
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: [210, 297],
  });
  if (normalizedPurchases.length === 0) {
    return null;
  }
  let firstPhysicalPage = true;
  normalizedPurchases.forEach((purchase) => {
    const lines = safeArray(purchase?.linespurchasedelivery);
    if (lines.length === 0) return;

    const taxGroups = groupTaxes(lines);
    const totalsRef = { totalPurchase: 0, totalTax: 0 };
    const numPages = Math.max(1, Math.ceil(lines.length / LINES_PER_PAGE));

    for (let pageIndex = 0; pageIndex < numPages; pageIndex += 1) {
      if (!firstPhysicalPage) {
        doc.addPage();
      }
      firstPhysicalPage = false;

      drawStaticHeader(doc, purchase, headerPrinterPurchase);
      drawPartyInfo(doc, purchase);
      drawTableHeader(doc);

      let yOffset = drawLinesPage(doc, lines, pageIndex, totalsRef);

      if (pageIndex === numPages - 1) {
        yOffset = drawTotals(doc, yOffset, purchase, taxGroups, totalsRef);
        drawSignatures(doc, purchase);
      }
    }
  });

  return doc.output("blob");
};

export default generatePurchaseSendEmailPdf;